<template>
	<div class="register-wrapper">
		<div ref="form" class="weui-form__control-area">
			<div class="weui-cells__group weui-cells__group_form">
				<div class="weui-cells weui-cells_form">
					<div class="weui-cell weui-cell_active">
						<div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
						<div class="weui-cell__bd">
							<!-- <input class="weui-input" v-model="registerForm.phonenumber" type="tel" maxlength="11"
								   required emptyTips="请输入手机号" placeholder="请输入手机号"/> -->
								   <span>{{ registerForm.phonenumber }}</span>
						</div>
						<!--<div class="weui-cell__ft">-->
							<!--<a class="weui-btn_reset weui-btn_icon">-->
								<!--<i id="showIOSDialog1" class="weui-icon-info-circle"></i>-->
							<!--</a>-->
						<!--</div>-->
					</div>
					
				</div>
				<!--<div class="weui-cells__tips"><a class="weui-link" href="javascript:">收不到验证码</a></div>-->
				<div class="weui-btn-area">
					<button class="weui-btn weui-btn_primary" @click="formValidate">注册</button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import { sendMes, xcxRegister } from "../../../api/coupon/register";
	import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: "xcxRegister",
		data () {
            return {
                alreadySend:false,
                second: 60,
                registerForm: {
					phonenumber: undefined,
				}
			}
		},
		computed: {
			...mapGetters(['userOpenid'])
		},
		created () {
			this.registerForm.phonenumber = this.$route.query.phone;
			this.formValidate()
		},
		methods: {
			...mapMutations({
                setUserPhone: "SET_USER_PHONE"
			}),
            /*验证输入框非空**/
            formValidate () {
      
                        this.$set(this.registerForm,'openid',localStorage.getItem('userOpenId')||this.userOpenid);
					
                        xcxRegister(this.registerForm).then(res =>{
							if (res.code == 200){
								this.$weui.alert('注册成功！请关闭小程序前往公众号畅停天下')
							    this.setUserPhone(this.registerForm.phonenumber);
                                localStorage.setItem('userId',res.data.id);
                                // let beforeUrl = localStorage.getItem("beforeUrl");
                                // if (beforeUrl) {
                                //     this.$router.push(beforeUrl);
                                // } else {
                                //     this.$router.push({name:'personalCenter'});
                                // }
							}
                        })
            
            },
            /* 获取验证码按钮操作**/
            getCode () {
                if (this.alreadySend){
                    return false
                }else {
                    if (this.registerForm.phonenumber) {
                        this.sendMsg()
					}else {
                        this.$weui.alert('请输入手机号')
					}

                }
			},
			sendMsg () {
              sendMes(this.registerForm.phonenumber).then(res =>{
                  if (res.code == 200) {
                      this.alreadySend = true;
                      this.timer();
				  }
			  })
			},
			timer () {
                let promise = new Promise((resolve, reject) => {
                    this.setTimer = setInterval(
                        () => {
                            this.second -= 1;
                            if (this.second <= 0) {
                                this.second = 60;
                                this.alreadySend = false;
                                resolve(this.setTimer)
                            }else {
                                this.alreadySend = true
                            }
                        }, 1000)
                });
                promise.then((setTimer) => {
                    clearInterval(setTimer)
                })
			},
			/*确认按钮操作**/
            handleConfirm () {
                let form = this.$refs["form"];
				this.formValidate(form)
			},
			xcxRegister(){

			},
		}
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.weui-cells__group_form .weui-cell{
		padding: 16px;
	}
	.weui-btn-area{
		margin-top 20px
		 .weui-btn{
			 width: 100%;
		 }
		p{
			font-size $article-p
			color $article-merchant-p
			line-height 20px
			padding-top 10px
		}
	}
</style>
